import { Flex, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing } from '../../theming';
import { BATCH_RESULTS, cadenceKey } from '../../utils/vinExtraction';
import { cardTitleStyle, labelStyle, mutedSmallStyle } from './vinExtractionStyles';
import { useNumberFormat } from './useNumberFormat';

const RESULT_SELECT_ID = 'vin-batches-result';

const BatchesHeader = ({ total, settings, result, onResultChange }) => {
    const { t } = useTranslation('vinExtraction');
    const { integer } = useNumberFormat();
    const cadence = cadenceKey(settings?.schedule?.trigger);
    const subtitle =
        total === null
            ? null
            : [t('batches.subtitle', { total: integer(total) }), cadence && t(`batches.cadence.${cadence}`)]
                  .filter(Boolean)
                  .join(' · ');

    return (
        <Flex justify="space-between" align="center" gap={spacing[2]} wrap="wrap">
            <Flex align="baseline" gap={spacing[1]} wrap="wrap">
                <h2 style={{ ...cardTitleStyle, margin: 0 }}>{t('batches.title')}</h2>
                {subtitle && <span style={mutedSmallStyle}>{subtitle}</span>}
            </Flex>
            <Flex align="center" gap={spacing[1]}>
                <label htmlFor={RESULT_SELECT_ID} style={labelStyle}>
                    {t('batches.resultLabel')}
                </label>
                <Select
                    id={RESULT_SELECT_ID}
                    value={result ?? 'all'}
                    onChange={value => onResultChange(value === 'all' ? undefined : value)}
                    style={{ minWidth: 150 }}
                    options={['all', ...BATCH_RESULTS].map(value => ({
                        value,
                        label: t(`batches.resultFilter.${value}`),
                    }))}
                />
            </Flex>
        </Flex>
    );
};

export default BatchesHeader;
